import * as React from 'react';
import { Button } from '@teamsnap/teamsnap-ui';
import SeasonList, { RefProps } from '../../components/season/season-list';
import SeasonEdit from '../../components/season/season-edit';
import { ActivitySeasonType } from '../../models/season';
import * as ShowOrganization from '../../core/gql/queries/show-organizations';
import * as GqlProgramExpanded from '../../core/gql/queries/program';
import SeasonGuide from 'components/program/season-guide/season-guide';
import { useQuery } from '@apollo/client';

import './seasons.scss';

const Seasons: React.FunctionComponent<any> = ({
  match: {
    params: { programId, orgId },
  },
}) => {
  const [selectedSeasonId, setSelectedSeasonId] = React.useState(null);
  const [selectedActivitySeasonType, setSelectedActivitySeasonType] = React.useState(null);
  const [shouldShowEditModal, setShouldShowEditModal] = React.useState(false);
  const [showSeasonStepper, setShowSeasonStepper] = React.useState(false);
  const [showArchived, setShowArchived] = React.useState(false);
  const SeasonsListRef = React.useRef<RefProps>(null);

  const { loading: orgLoading, data: orgData } = useQuery(ShowOrganization.ORG_QUERY_FOR_SEASONS_PAGE, {
    variables: { organizationId: +orgId },
    skip: !orgId,
  });

  const { loading: programLoading, data: programData } = useQuery(GqlProgramExpanded.QUERY, {
    variables: { programId: parseInt(programId) },
  });

  const showSeason = (type: ActivitySeasonType, id?: number) => {
    setSelectedSeasonId(id);
    setSelectedActivitySeasonType(type);
    setShouldShowEditModal(true);
  };

  if (!programId) return null;

  return (
    <div id="seasons" className="container">
      {!programLoading && !orgLoading && (
        <>
          <div className="page-content page-content u-xs-padXl u-flexExpandSides">
            <div className="page-content-header Grid u-flexAlignItemsCenter">
              <div className="Grid-cell u-xs-size1of2">
                <h1>{programData.showProgram.name}</h1>
                <p>{programData.showProgram.description}</p>
                <div className="Checkbox u-spaceTopSm" data-testid="hide-archived-seasons-checkbox">
                  <input
                    type="checkbox"
                    className="Checkbox-input"
                    name="includeArchivedSeasons"
                    onClick={() => setShowArchived(!showArchived)}
                    onChange={() => {}}
                    checked={!showArchived}
                  />
                  <label htmlFor="addLegacySeason" className="Checkbox-label">
                    Hide Archived Seasons
                  </label>
                </div>
              </div>
              <div className="Grid-cell u-xs-size1of2 u-textRight">
                {/* <Button color="primary" icon="plus" iconPosition="left" onClick={() => showSeason(ActivitySeasonType.LegacyOrgSeason, null)}>
                    Create New Legacy Season
                  </Button>
                  &nbsp;&nbsp; */}
                <Button
                  data-testid="program-guide-start-button"
                  color="primary"
                  icon="plus"
                  mods="u-spaceRightSm"
                  onClick={() => setShowSeasonStepper(!showSeasonStepper)}
                >
                  Guide My Setup
                </Button>
                <Button
                  color="primary"
                  icon="plus"
                  iconPosition="left"
                  onClick={() => showSeason(ActivitySeasonType.ClubSeason, null)}
                >
                  Create New Season
                </Button>
              </div>
            </div>

            <div className="page-content-body">
              <SeasonList
                ref={SeasonsListRef}
                selectSeasonIdCallback={showSeason}
                program={programData.showProgram}
                showArchived={showArchived}
              />
            </div>
          </div>

          {shouldShowEditModal && (
            <SeasonEdit
              program={programData.showProgram}
              isOpen={shouldShowEditModal}
              onClose={() => setShouldShowEditModal(false)}
              selectedSeasonId={selectedSeasonId}
              activitySeasonType={selectedActivitySeasonType}
            />
          )}

          {showSeasonStepper && (
            <SeasonGuide
              setOpen={setShowSeasonStepper}
              organization={orgData.showOrganization}
              program={programData.showProgram}
              onCreationComplete={() => SeasonsListRef?.current.refetchSeasons()}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Seasons;
